import React from 'react'
import { getTranslatedMessage } from "../utils/translations";

export const MenuItem = ({msg, onClick, Icon, disabled}) => (
	<button
        onClick={onClick}
        disabled={disabled}
		style={{
			width: 180,
			padding: 18,
			fontSize: 14,
			borderWidth: 0,
			borderRadius: 8,
			display: "flex",
			background: "white",
			alignItems: "center",
		}}
	>
		{Icon ? <Icon style={{margin: "0 4px", width: 20, height: 14}} /> : null}
		{getTranslatedMessage(msg)}
	</button>
)




// WEBPACK FOOTER //
// ./src/components/MenuItem.js